export default "__VITE_ASSET__f2ca1f22__"